export default __webpack_public_path__ + "static/media/empty-state-banner.17859eed.svg";